import { isPlatformBrowser } from '@angular/common';
import { CookieOptions } from '@laurentgoudet/ngx-cookie';

export function cookieOptionsFactory(platformId: Object): CookieOptions {
  return isPlatformBrowser(platformId)
    ? {
        path: '/',
        domain: window.location.hostname.match(/freelancer.*$/)
          ? `.${
              (window.location.hostname.match(/freelancer.*$/) as string[])[0]
            }`
          : `${window.location.hostname}`,
        secure: window.location.protocol === 'https',
      }
    : {};
}
